var v1="<div class=\"chart stroke-chart\"></div><div class=\"title\">{{:: '_STROKE_ANALYSIS.TITLE' | translate }}</div><div class=\"value1\">{{ strokeData.avg_shot_par3 | number: 2 }}</div><div class=\"value2\">{{ strokeData.avg_shot_par4 | number: 2 }}</div><div class=\"value3\">{{ strokeData.avg_shot_par5 | number: 2 }}</div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis-charts/stroke-analysis/stroke-analysis.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/analysis-charts/stroke-analysis/stroke-analysis.jade
// module id = 475
// module chunks = 0